import { API_URLS } from '../helpers/api/API_URLS';
import { basicGET } from '../helpers/api/fetchParams';

export async function getTemplateReport(templateId) {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.CRM+"report/newsletter.csv?startDate=2020-01-01&templateId="+templateId+"&allForTemplate=TRUE", basicGET(token))
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.text();
    return data;
}

export async function getScheduledNewsletters() {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.CRM+"report/newsletters?scheduled=true", basicGET(token));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceCrm.js